import { HostListener, Component, OnInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { TargetDetectionService } from 'src/app/service/targetDetectionservice';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, RoutesRecognized } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BreakDialog } from '../dialogs/break/break.dialog';
import { FeedbackCountDialog } from '../dialogs/feedbackCount/feedbackCount.dialog';
import { FeedbackDialog } from '../dialogs/feedback/feedback.dialog';
import { LoadingDialog } from '../dialogs/loading/loading.dialog';
import moment from 'moment'
import { TranslateService } from '@ngx-translate/core';
import { TaskService } from 'src/app/service/tasks.service';


//utils
import utils from 'src/app/utils/utils';

@Component({
  selector: 'app-target-detection',
  templateUrl: './target-detection.component.html',
  styleUrls: ['./target-detection.component.css']
})
export class TargetDetectionComponent implements OnInit, OnDestroy, AfterViewChecked {

  private ctx: AudioContext;
  ready = false;
  started = false;
  trials = []
  round = 0;
  block = 0
  cue: string
  showCue: boolean
  showFixation: boolean
  showStimulus: boolean
  stimulusSide: string //left or right
  stimulusDarker: string //top or bottom
  sound: boolean
  demo = true //change to true
  audio: HTMLAudioElement
  collectResponse: boolean
  correctAnswersCount = 0
  answers = [] //qui
  wrongAnswers = [] // contains also the not given ones
  allAnswers = [] // correct, wrong and not given
  timeStamp = null;
  answered = false
  answerCorrectness: boolean
  feedbackTime: number
  demoTrials = []
  demoScreen = false
  correctAnswer: string
  timeOut: any
  audioSource: string //can be speakers or headphones
  demoType = 'slow' //can be slow or normal 
  done = false
  first = true
  charged2 = false;

  wrongTrials = []
  redoTrials = []
  extraTrials = false //true when re doing wrongly answered trials

  loading = true
  getReady = false
  sumResponseTime = 0 //used to compute acg response time for feedback
  validResponseTime = 0 //used to remove from avg response time computation not answered trials
  height: number

  finished = false
  totalTrials = 128
  // totalTrials = 5 //rremove: test only
  displayedRound = 0

  //used to display start button on test view to begin experiment
  startButton = false

  cueAppearanceTimeStamp





  constructor(
    private router: Router,
    private targetDetectionService: TargetDetectionService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private taskService: TaskService) {

  }
  ngOnDestroy(): void {
    if (this.timeOut)
      clearTimeout(this.timeOut)
  }

  ngOnInit() {
    AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext;
    this.ctx = new AudioContext();

    this.targetDetectionService.check_exp()
      .then(data => {
        this.done = data.body.valid
        this.charged2 = true
        this.loading = false
        if (this.done) {
          this.targetDetectionService.get_trials()
            .then((resp) => {
              this.ready = true //stops loading spinner
              const auxArray = [[], []]
              resp.body.forEach((item, index) => {
                if (index < 128)
                // if (index < 5) //rremove: test only

                  auxArray[0].push(item)
                else
                  auxArray[1].push(item)
              })
              this.trials = auxArray
              // console.table(this.trials[0])

              //fill demo 
              this.chooseDemo()
            })

        }

      })
    this.initAudio()

  }

  ngAfterViewChecked(): void {
    this.height = document.getElementById('target-detection').scrollHeight
  }

  chooseDemo = () => {
    const auxDemo = []
    for (let i = 0; i < 10; i++) {
      if (i < 5)
        auxDemo.push(this.trials[0][Math.floor(Math.random() * this.trials[0].length)]) //length should always be 128!
      else
        auxDemo.push(this.trials[1][Math.floor(Math.random() * this.trials[1].length)])
    }
    this.demoTrials = auxDemo
  }


  initAudio() {
    let aud = new Audio();
    aud.src = '../../assets/7plus13.wav'
    aud.load();
    this.audio = aud
    return
  }

  start() {
    this.started = true
    if (!this.ready) {
      setTimeout(() => this.start(), 1000)
    }
    else {
      this.startButton = true
    }
  }

  begin() {
    this.startButton = false
    this.getReady = true
    setTimeout(() => window.scrollTo(0, this.height), 75)
    setTimeout(() => {
      this.getReady = false
      setTimeout(() => this.doRound(), 1000)
    }, 1000) //change back to 9000
  }

  startExperiment() {
    this.demo = false
    this.demoScreen = false
    this.started = true
    this.startButton = true
    /*
    this.getReady = true
    setTimeout(() => window.scrollTo(0, this.height), 75)
    setTimeout(() => {
      this.getReady = false
      setTimeout(() => this.doRound(), 1000)
    }, 9000)
    */
  }

  redoDemo(demoType: string) {
    this.chooseDemo()
    this.started = true
    this.demoType = demoType
    this.startButton = true
    /*
    this.getReady = true
    setTimeout(() => window.scrollTo(0, this.height), 75)
    setTimeout(() => {
      this.getReady = false
      setTimeout(() => this.doRound(), 1000)
    }, 9000)
    */
  }

  setAudioType(type: string) {
    this.audioSource = type
  }

  setCue = (currentTrial) => {
    const target = currentTrial.target
    if (currentTrial.cue === 'valid') {
      this.cue = target === 'left' ? 'left' : 'right'
    }
    else if (currentTrial.cue === 'invalid') {
      this.cue = target === 'left' ? 'right' : 'left'
    }
    else {
      //neutral
      this.cue = 'neutral'
    }
  }


  wait(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  submit() {
    const dialogRef = this.dialog.open(LoadingDialog, { disableClose: true })
    this.targetDetectionService.save(this.answers)
      .then(() => {
        this.targetDetectionService.save_wrong(this.wrongAnswers)
      })
      .then(resp => {
        dialogRef.close()
        this.started = false
        this.finished = true
        setTimeout(() => {
          this.router.navigate([''])
        }, 3000)
      })
      .then(() => {
        this.taskService.saveCompletedTask({ "type": "TargetDetection"})
      })
  }

  async doRound() {

    let currentTrial

    if (this.demo)
      currentTrial = this.demoTrials[this.round]

    else if (!this.extraTrials)
      currentTrial = this.trials[this.block][this.round]

    else
      currentTrial = this.redoTrials[this.round]

    // console.log(currentTrial)
    this.correctAnswer = currentTrial.position

    //show arrow for 150 ms
    this.setCue(currentTrial)
    this.showCue = true
    this.cueAppearanceTimeStamp = new Date().getTime();
    // console.log("cueAppearanceTimestamp", this.cueAppearanceTimeStamp)
    await this.wait(150)
    this.showCue = false

    //show fixation cross for trial defined time (between 600 and 900 ms)
    this.showFixation = true
    await this.wait(currentTrial.soa)
    this.showFixation = false

    //show stimulus (circle) for 100 ms
    this.stimulusSide = currentTrial.target === 'left' ? 'left' : 'right'
    this.stimulusDarker = currentTrial.position === 'up' ? 'top' : 'bottom'

    //show image on screen
    this.showStimulus = true
  }


  //executed once the image is actually displayed on the screen
  async completeRound() {

    if (this.demo) {
      this.timeStamp = moment()
      this.collectResponse = true

      if (this.demoTrials[this.round].modal === 'bimodal') {
        // await this.audio.play()
        utils.playCustomBeep(this.ctx)
      }

      const stimulusTime = this.demoType === 'slow' ? 1200 : 100
      await this.wait(stimulusTime)

      //this.audio.pause()
      this.showStimulus = false
      this.showFixation = true //show cross

      await this.wait(1000)

      this.collectResponse = false

      if (!this.answered) {
        this.feedbackTime = 0
        this.answerCorrectness = false
      }
      else
        this.answered = false

      //wait 
      await this.wait(1400)
      this.showFixation = false

      //show feedback
      const dialogRef = this.dialog.open(FeedbackDialog, {
        data: {
          correctness: this.answerCorrectness,
          responseTime: this.feedbackTime,
          showTime: true
        },
        disableClose: true
      })

      //close feedback after 1700 ms
      this.timeOut = setTimeout(() => dialogRef.close(), 1700)

      dialogRef.afterClosed()
        .subscribe(() => {
          this.round++
          if (this.round < 10)
            this.doRound()
          else {
            this.started = false
            this.demoScreen = true
            this.round = 0 //reset rounds!
            this.correctAnswersCount = 0
          }
        })
    }
    else {

      //LIVE when stimulus appears
      this.timeStamp = moment()
      // console.log("stimulusAppearenceTimeStamp: ", this.timeStamp.toDate().getTime())
      this.collectResponse = true
      let currentTrial

      if (!this.extraTrials)
        currentTrial = this.trials[this.block][this.round]

      else
        currentTrial = this.redoTrials[this.round]

      if (currentTrial.modal === 'bimodal') {
        // await this.audio.play();
        utils.playCustomBeep(this.ctx)

      }

      await this.wait(100)

      //this.audio.pause()
      this.showStimulus = false
      this.showFixation = true //show cross
      await this.wait(1000)

      this.collectResponse = false
      if (!this.answered) {

        if ((this.round >= this.answers.length && this.displayedRound < this.trials[0].length) || (this.block === 1 && this.round >= this.answers.length - 128 && this.displayedRound < this.trials[1].length)) {
        // if ((this.round >= this.answers.length && this.displayedRound < this.trials[0].length) || (this.block === 1 && this.round >= this.answers.length - 5 && this.displayedRound < this.trials[1].length)) { //rremove: test only

          // console.log("AAAAAAAAAAAAAAAAAAAAA")
          this.wrongTrials.push(this.trials[this.block][this.round]) // probably bug here. IT WAS HERE!!!
          // console.log("ho inserito il seguente wrontTrial: risposta non data")
          // console.log("trial_index: ", this.round)
          // console.log("answers.len: ", this.answers.length)
          // console.log(this.trials[this.block][this.round])

          // console.log("------------------")
          // console.log("this.round: ", this.round)
          // console.log("this.answers.length: ", this.answers.length)
          // console.log("this.displayedRound: ", this.displayedRound)
          // console.log("this.trials[1].length: ", this.trials[1].length)

        }

        else {

          // console.log("BBBBBBBBBBBBBBBBBBBBB")
          // console.log("-------------------")
          // console.log("this.round: ", this.round)
          // console.log("this.answers.length: ", this.answers.length)
          // console.log("this.displayedRound: ", this.displayedRound)
          // console.log("this.trials[1].length: ", this.trials[1].length)
          let indexToPush = -1
          let indexesOfRoundsToBeRedone = []
          let indexesOfCorrectGivenAnswers = this.answers.map(a => a.index) //ok
          for (const trial of this.trials[this.block]) {
            // console.log(trial.index) //ok
            if (!indexesOfCorrectGivenAnswers.includes(trial.index)) {
              indexesOfRoundsToBeRedone.push(trial.index)
            }
          }
          // console.log(indexesOfRoundsToBeRedone) //ok

          let ok = false;
          let tmpIndex = 0
          // console.log("almeno sono qui")

          let indexesOfWrongTrials = this.wrongTrials.length > 0 ? this.wrongTrials.map(t => t.index) : [] //ok

          // console.log("indexesOfWrongTrials")
          // console.log(indexesOfWrongTrials)

          // console.log("indexesOfRoundsToBeRedone")
          // console.log(indexesOfRoundsToBeRedone)

          while (!ok) {
            if (!indexesOfWrongTrials.includes(indexesOfRoundsToBeRedone[tmpIndex])) {

              // console.log(indexesOfRoundsToBeRedone[tmpIndex] + " non è incluso in indexesOfWrongTrials")
              indexToPush = this.trials[this.block].map(t => t.index).indexOf(indexesOfRoundsToBeRedone[tmpIndex])
              // console.log("index to push: ", indexToPush)
              ok = true;
            }
            tmpIndex++
          }

          this.wrongTrials.push(this.trials[this.block][indexToPush])
          // console.log("ho inserito il seguente wrontTrial: risposta non data")
          // console.log("trial_index: ", this.round + this.answers.length)
          // console.log("answers.len: ", this.answers.length)
          // console.log(this.trials[this.block][indexToPush - 1])
        }


        //.log("-----AllwrongTrials-----")
        // console.table(this.wrongTrials)

        this.totalTrials++
        this.wrongAnswers.push({
          round: this.displayedRound + 1,
          trialIndex: currentTrial.index,
          block: this.block + 1,
          correctAnswer: this.correctAnswer,
          // givenAnswer: "-",
          givenAnswer: null,
          // responseTime: "-",
          responseTime: null,
          cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
          stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
          // buttonPressedTimeStamp: "-"
          buttonPressedTimeStamp: null

        });

        this.allAnswers.push({
          round: this.displayedRound + 1,
          trialIndex: currentTrial.index,
          block: this.block + 1,
          correctAnswer: this.correctAnswer,
          givenAnswer: null,
          responseTime: null,
          cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
          stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
          buttonPressedTimeStamp: null
        });

        // console.log("CORRECT")
        // console.table(this.answers)
        // console.log("WRONG")
        // console.table(this.wrongAnswers)
        // console.log("WRONG TRIALS")
        // console.table(this.wrongTrials)
        // console.log("ALL")
        // console.table(this.allAnswers)
      }
      else
        this.answered = false

      //wait 1400 ms
      await this.wait(1400)

      this.showFixation = false

      //break every 36
      if ((this.displayedRound + 1) % 36 === 0 && !((this.displayedRound + 1) === this.totalTrials)) {

        const dialogRef = this.dialog.open(BreakDialog, {
          data: {
            feedback: true,
            correctAnswersCount: this.correctAnswersCount,
            totalAnswersCount: this.displayedRound + 1,
            avgResponseTime: this.sumResponseTime ? (this.sumResponseTime / this.validResponseTime).toFixed(0) : '0'
          },
          disableClose: true
        });
        dialogRef.afterClosed()
          .subscribe(() => {
            this.round++ //move to next round
            if ((!this.extraTrials && (this.round < 128)) || (this.extraTrials && (this.round < this.redoTrials.length))) {
            // if ((!this.extraTrials && (this.round < 5)) || (this.extraTrials && (this.round < this.redoTrials.length))) { //rremove: test only

              this.displayedRound++
              this.getReady = true
              this.wait(3000)
                .then(() => {
                  this.getReady = false
                  this.wait(1000)
                    .then(() => {
                      this.doRound()
                    })
                })
            }
            else {
              // block (or redone trial) finished
              if (this.wrongTrials.length !== 0) {

                //still trials to redo
                //this.totalTrials = this.totalTrials + this.wrongTrials.length
                this.extraTrials = true
                this.round = 0
                this.redoTrials = [...this.wrongTrials]
                this.wrongTrials = []
                this.displayedRound++
                this.getReady = true
                this.wait(3000)
                  .then(() => {
                    this.getReady = false
                    this.wait(1000)
                      .then(() => {
                        this.doRound()
                      })
                  })
              }
            }

          })
      }
      else {
        this.round++

        if ((!this.extraTrials && (this.round < 128)) || (this.extraTrials && (this.round < this.redoTrials.length))) {
        // if ((!this.extraTrials && (this.round < 5)) || (this.extraTrials && (this.round < this.redoTrials.length))) { //rremove: test only

          this.displayedRound++
          this.doRound()
        }

        else {

          // block (or redone trial) finished
          if (this.wrongTrials.length !== 0) {

            //still trials to redo
            //this.totalTrials = this.totalTrials + this.wrongTrials.length
            this.extraTrials = true
            this.round = 0
            this.redoTrials = [...this.wrongTrials]
            this.wrongTrials = []
            this.displayedRound++
            this.doRound()
          }
          else {
            //No wrong trials to redo --> finish block

            const dialogRef = this.dialog.open(FeedbackCountDialog, {
              data: {
                type: 'count',
                // ERROR: change this.totalTrials with correctAnswerCount
                correctAnswersCount: this.correctAnswersCount, //this.totalTrials,
                totalAnswersCount: this.totalTrials
              },
              disableClose: true
            });

            dialogRef.afterClosed()
              .subscribe(() => {


                this.started = false
                this.round = 0 //reset rounds!
                this.displayedRound = 0
                this.totalTrials = 128
                // this.totalTrials = 5 //rremove: test only

                this.block++ //move to next block
                this.correctAnswersCount = 0
                this.sumResponseTime = 0
                this.validResponseTime = 0
                this.extraTrials = false

                if (this.block === 2) {
                  this.submit()
                }
              })
          }
        }
      }
    }
  }


  //prevent scrolling
  @HostListener('window:keydown', ['$event'])
  keyEventDown(event: KeyboardEvent) {
    if (event.key === KEY_CODE.UP_ARROW || event.key === KEY_CODE.DOWN_ARROW)
      event.preventDefault()
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.started && this.collectResponse) {

      const responseTimestamp = moment() // qui timestamp when user pushes button
      // console.log("responseTimestamp", responseTimestamp.toDate().getTime())
      const respTime = responseTimestamp.diff(this.timeStamp) // difference between timestamp when user pushes button and timestamp when stimulus appears
      this.feedbackTime = respTime
      const currentTrial = !this.extraTrials ? this.trials[this.block][this.round] : this.redoTrials[this.round]


      if (!this.demo) {
        this.validResponseTime++ //answer given --> valid for avg computation
        this.sumResponseTime += respTime //sum response times
      }

      if (event.key === KEY_CODE.UP_ARROW) {
        this.answered = true

        if (this.correctAnswer === 'up') {
          this.correctAnswersCount++
          this.answerCorrectness = true
          if (!this.demo) {
            this.answers.push({
              index: currentTrial.index,
              response: 'up',
              // response: 'TOP',
              responseTime: respTime,
              audioSource: this.audioSource,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
            this.allAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "up",
              // givenAnswer: "TOP",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });


          }
        }
        else {
          this.answerCorrectness = false
          if (!this.demo) {
            this.wrongTrials.push(currentTrial)
            // console.log("ho inserito il seguente wrontTrial: risposta sbabliata")
            // console.log(currentTrial)
            this.totalTrials++

            this.wrongAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "up",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
            this.allAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "up",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
          }

        }

        this.collectResponse = false
      } else if (event.key === KEY_CODE.DOWN_ARROW) {
        this.answered = true

        if (this.correctAnswer === 'down') {
          this.correctAnswersCount++
          this.answerCorrectness = true
          if (!this.demo) {
            this.answers.push({
              index: currentTrial.index,
              response: 'down',
              // response: 'BOTTOM',
              responseTime: respTime,
              audioSource: this.audioSource,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
            this.allAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "down",
              // givenAnswer: "BOTTOM",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
            // this.submit()
          }
        }
        else {
          this.answerCorrectness = false
          if (!this.demo) {
            this.wrongTrials.push(currentTrial)
            // console.log("ho inserito il seguente wrontTrial: risposta sbabliata")
            // console.log(currentTrial)
            this.totalTrials++
            this.wrongAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "down",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
            this.allAnswers.push({
              round: this.displayedRound + 1,
              trialIndex: currentTrial.index,
              block: this.block + 1,
              correctAnswer: this.correctAnswer,
              givenAnswer: "down",
              responseTime: respTime,
              cueAppearanceTimeStamp: this.cueAppearanceTimeStamp,
              stimulusAppearanceTimeStamp: this.timeStamp.toDate().getTime(),
              buttonPressedTimeStamp: responseTimestamp.toDate().getTime()
            });
          }

        }

        this.collectResponse = false
      }
    }

    // console.log("CORRECT")
    // console.table(this.answers)

    // console.log("WRONG")
    // console.table(this.wrongAnswers)

    // console.log("WRONG TRIALS")
    // console.table(this.wrongTrials)

    // console.log("ALL")
    // console.table(this.allAnswers)

  }

}

export enum KEY_CODE {
  UP_ARROW = 'ArrowUp',
  DOWN_ARROW = 'ArrowDown'
}
